//defines the cookie name
export const playerCookie = 'online-quizmaster'; //playQuiz Cookie
export const ConsentCookie = 'online-quizmaster-consent'; //tracking consent cookie